<script setup lang="ts">
import { computed } from 'vue';
import { mouthDashes, mouthFaces, mouthOutline } from '~/utils/auth-pattern';

interface Props {
	/** Draws the highlighted treatment, layered over a resting mouth so the two can cross-fade. */
	active?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	active: false,
});

/** The highlighted mouth is drawn entirely in solid white outline, faces included. */
const ACTIVE_STROKE = 'stroke-white stroke-[1.35px] [stroke-dasharray:none] [stroke-linecap:round] [stroke-linejoin:round]';

const faceClass = computed(() => (props.active ? ACTIVE_STROKE : ''));
const mainFaceClass = computed(() => (props.active ? 'fill-white' : 'fill-(--auth-pattern-face)'));

const dashClass = computed(() => (props.active
	? ACTIVE_STROKE
	: 'stroke-(--auth-pattern-dash) stroke-[1.05px] [stroke-dasharray:4_4] [stroke-linecap:round]'));

const outlineClass = computed(() => (props.active ? ACTIVE_STROKE : 'stroke-white stroke-[1.05px]'));
</script>

<template>
	<g>
		<path
			v-for="face in mouthFaces"
			:key="face.path"
			class="[vector-effect:non-scaling-stroke]"
			:class="[faceClass, face.main ? mainFaceClass : 'fill-primary']"
			:d="face.path"
			fill-rule="evenodd"
			clip-rule="evenodd"
		/>
		<path
			v-for="dash in mouthDashes"
			:key="dash"
			class="fill-none [vector-effect:non-scaling-stroke]"
			:class="dashClass"
			:d="dash"
		/>
		<path
			class="fill-none [vector-effect:non-scaling-stroke]"
			:class="outlineClass"
			:d="mouthOutline"
		/>
	</g>
</template>
